import { Tab, Tabs as MuiTabs } from '@mui/material';
import { SystemColors } from 'melp-design/style';

interface Props<T extends string> {
  value: T;
  onChange: (value: T) => void;
  items: Array<{ value: T; label: string }>;
}

export const Tabs = <T extends string>({
  value,
  onChange,
  items,
}: Props<T>) => {
  return (
    <MuiTabs
      value={value}
      onChange={(_, v) => onChange(v)}
      TabIndicatorProps={{
        sx: { display: 'none' },
      }}
      sx={{
        minHeight: 'auto',
        '& .MuiTabs-flexContainer': {
          gap: 0.5,
        },
      }}
    >
      {items.map((item) => (
        <Tab
          key={item.value}
          value={item.value}
          label={item.label}
          disableRipple
          sx={{
            px: 1.75,
            py: 1,
            borderRadius: 1,
            '&:hover': {
              color: SystemColors.grey[55],
              backgroundColor: SystemColors.grey[98],
            },
            '&.Mui-selected': {
              color: SystemColors.primary.base,
              backgroundColor: SystemColors.primary.tint,
              fontWeight: 400,
            },
          }}
        />
      ))}
    </MuiTabs>
  );
};
